var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfianza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.409,
    height: 55.577,
    viewBox: "0 0 61.409 55.577",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Confianza",
    transform: "translate(-3.521 -7.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9055",
    "data-name": "Path 9055",
    className: "cls-1",
    d: "M43.8,33.295a3.5,3.5,0,1,0-3.5-3.5A3.52,3.52,0,0,0,43.8,33.295Zm0-4.949a1.518,1.518,0,1,1-1.518,1.518A1.535,1.535,0,0,1,43.8,28.346Z",
    transform: "translate(-12.51 -6.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9056",
    "data-name": "Path 9056",
    className: "cls-1",
    d: "M48.509,46.9a6,6,0,1,0-6,6A6.027,6.027,0,0,0,48.509,46.9Zm-6,4.025A4.025,4.025,0,1,1,46.53,46.9,4,4,0,0,1,42.5,50.93Z",
    transform: "translate(-11.218 -11.233)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9057",
    "data-name": "Path 9057",
    className: "cls-1",
    d: "M29.717,43.566a3.647,3.647,0,0,0-.2-2.639,3.14,3.14,0,0,0-2.046-1.716,3.429,3.429,0,0,0-4.355,2.244,3.647,3.647,0,0,0,.2,2.639,3.14,3.14,0,0,0,2.046,1.716,2.989,2.989,0,0,0,1.056.2A3.5,3.5,0,0,0,29.717,43.566ZM27.8,42.972a1.523,1.523,0,1,1-2.9-.924,1.561,1.561,0,0,1,.726-.858,1.19,1.19,0,0,1,.66-.132,1.123,1.123,0,0,1,.462.066h0A1.428,1.428,0,0,1,27.8,42.972Z",
    transform: "translate(-6.612 -10.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9058",
    "data-name": "Path 9058",
    className: "cls-1",
    d: "M35.077,60.26a3.234,3.234,0,0,0-2.573-.594,3.383,3.383,0,0,0-2.244,1.386,3.234,3.234,0,0,0-.594,2.573,3.383,3.383,0,0,0,1.386,2.244,3.3,3.3,0,0,0,2.046.66,1.286,1.286,0,0,0,.528-.066,3.383,3.383,0,0,0,2.244-1.386,3.234,3.234,0,0,0,.594-2.573A3.291,3.291,0,0,0,35.077,60.26Zm-.792,3.7a1.564,1.564,0,0,1-.99.594,1.379,1.379,0,0,1-1.122-.264,1.55,1.55,0,0,1-.33-2.112h0a1.411,1.411,0,0,1,1.188-.594,1.326,1.326,0,0,1,.858.264A1.514,1.514,0,0,1,34.285,63.955Z",
    transform: "translate(-8.871 -17.594)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9059",
    "data-name": "Path 9059",
    className: "cls-1",
    d: "M52.551,60.259a3.487,3.487,0,0,0-.792,4.883A3.383,3.383,0,0,0,54,66.527c.2,0,.4.066.528.066a3.3,3.3,0,0,0,2.046-.66,3.547,3.547,0,0,0,.792-4.883A3.4,3.4,0,0,0,52.551,60.259Zm2.969,4.025a1.379,1.379,0,0,1-1.122.264,1.5,1.5,0,0,1-.66-2.705,1.451,1.451,0,0,1,.858-.264,1.411,1.411,0,0,1,1.188.594A1.48,1.48,0,0,1,55.52,64.284Z",
    transform: "translate(-16.183 -17.593)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9060",
    "data-name": "Path 9060",
    className: "cls-1",
    d: "M62.887,39.4a3.361,3.361,0,0,0-2.639-.2A3.729,3.729,0,0,0,58.2,40.919a3.361,3.361,0,0,0-.2,2.639A3.729,3.729,0,0,0,59.719,45.6,3.514,3.514,0,0,0,61.3,46a2.989,2.989,0,0,0,1.056-.2A3.729,3.729,0,0,0,64.4,44.087a3.361,3.361,0,0,0,.2-2.639A3.481,3.481,0,0,0,62.887,39.4Zm-.264,3.827a1.561,1.561,0,0,1-.858.726,1.623,1.623,0,0,1-1.122-.066,1.561,1.561,0,0,1-.726-.858,1.623,1.623,0,0,1,.066-1.122,1.561,1.561,0,0,1,.858-.726,1.123,1.123,0,0,1,.462-.066,1.952,1.952,0,0,1,.66.132,1.561,1.561,0,0,1,.726.858A1.146,1.146,0,0,1,62.623,43.229Z",
    transform: "translate(-18.468 -10.593)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9061",
    "data-name": "Path 9061",
    className: "cls-1",
    d: "M54.147,33.831A19.542,19.542,0,1,0,35.6,59.5a19.081,19.081,0,0,0,6-.99A19.451,19.451,0,0,0,54.147,33.831ZM41.015,56.662A17.591,17.591,0,0,1,30.128,23.207a17.273,17.273,0,0,1,5.477-.858,17.994,17.994,0,0,1,7.984,1.914,17.582,17.582,0,0,1,7.654,23.623A17.687,17.687,0,0,1,41.015,56.662Z",
    transform: "translate(-4.251 -4.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9062",
    "data-name": "Path 9062",
    className: "cls-1",
    d: "M55.042,12.84a.957.957,0,0,0-1.386,0l-2.9,2.9A28.108,28.108,0,0,0,22.709,9.211,27.812,27.812,0,0,0,4.893,44.25a27.77,27.77,0,0,0,26.394,19.2,28.037,28.037,0,0,0,20.06-8.512L54.91,58.5a.992.992,0,0,0,.726.264h0a1.06,1.06,0,0,0,.726-.33,36.047,36.047,0,0,0,5.015-7.192A32.912,32.912,0,0,0,55.042,12.84ZM39.271,60.218A25.813,25.813,0,1,1,23.3,11.125a25.985,25.985,0,0,1,26,6.071l-2.573,2.573a.992.992,0,0,0-.264.726,1.06,1.06,0,0,0,.33.726A20.96,20.96,0,0,1,50.819,45.9h0a23.347,23.347,0,0,1-2.9,4.289.936.936,0,0,0,.066,1.32l2.046,2.046A26.87,26.87,0,0,1,39.271,60.218Zm20.258-9.9a30.808,30.808,0,0,1-4.025,6l-5.543-5.543a23.346,23.346,0,0,0-1.122-30.354l5.543-5.543A30.963,30.963,0,0,1,59.529,50.32Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfianza);
export default __webpack_public_path__ + "static/media/Confianza.6a9cb1ece000a3b4950628f34504f0c8.svg";
export { ForwardRef as ReactComponent };